import { gql } from "@apollo/client";

export const MassChangeMutation = gql`
  mutation MassChangeMutation($input: ItemBulkUpdateInput!) {
    itemBulkUpdate(input: $input)
  }
`;
